import { AxiosResponse } from 'axios';
import api from 'api/base';
import {
  CreateRoleRequest,
  GetRolesByPartnerNameResponse,
  GetRolesListResponseWithPagination,
  RoleResponse,
  RoleWithPermissionsResponse,
} from 'features/admin-roles/api/types';

export const getRolesList = async (params: {
  page: number;
  limit: number;
  selectedPermission?: number;
}): Promise<AxiosResponse<GetRolesListResponseWithPagination>> => {
  return api.get<GetRolesListResponseWithPagination>('/admin/roles', {
    params,
  });
};

export const getRolesByPartnerName = async (params: {
  partnerName?: string;
}): Promise<AxiosResponse<GetRolesByPartnerNameResponse>> => {
  return api.get<GetRolesByPartnerNameResponse>('/admin/roles/partner', {
    params,
  });
};

export const createAdminRole = async (
  data: CreateRoleRequest
): Promise<AxiosResponse<RoleResponse>> => {
  return api.post<RoleResponse>('/admin/roles', data);
};

export const getAdminRole = async (params: {
  roleId: number;
}): Promise<AxiosResponse<RoleWithPermissionsResponse>> => {
  return api.get<RoleWithPermissionsResponse>(`/admin/roles/${params.roleId}`);
};

export const updateAdminRole = async ({
  roleId,
  ...data
}: CreateRoleRequest & { roleId: number }): Promise<
  AxiosResponse<RoleResponse>
> => {
  return api.post<RoleResponse>(`/admin/roles/update/${roleId}`, data);
};

export const deleteAdminRole = async ({
  roleId,
}: {
  roleId: number;
}): Promise<number> => {
  await api.post<void>(`/admin/roles/delete/${roleId}`);
  return roleId;
};

export const deleteAdminRoles = async (
  roleIds: number[]
): Promise<number[]> => {
  await api.post<void>('/admin/roles/delete-multiple', { roleIds });
  return roleIds;
};
